import { render } from "./AvaInitials.vue?vue&type=template&id=a0011f70&ts=true"
import script from "./AvaInitials.ts?vue&type=script&lang=ts&external"
export * from "./AvaInitials.ts?vue&type=script&lang=ts&external"

import "./AvaInitials.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__